import extraMenuState from '@/store/modules/semis';

export default {
  modules: {
    extraMenuState,
  },
};
